function joinClassNames(...classNames) {
    return classNames
        .filter((className) => className !== '')
        .join(' ');
}

export { joinClassNames };
